export default "__VITE_ASSET__smpvAD0M__"